module.exports = __webpack_public_path__ + "static/media/straight_line.e647efb3.svg";